import { cUtil } from "../../../functions/util";

export class cAdminCustomerSelect {
  label_title   = document.createElement('label');
  input_select  = document.createElement('input');
  button_clear  = document.createElement('button');
  div_current   = document.createElement('div');
  div_customers = document.createElement('div');
  input_json    = document.createElement('input');
  parent        = document.querySelector('.c-admin-user-customer')        as HTMLElement;
  script        = document.querySelector('.c-admin-user-customer script') as HTMLScriptElement;

  constructor() {

    const customers = JSON.parse(this.script.innerText) as UserCustomer[];
    
    // ---- Structure ----
    this.parent.append(this.label_title);
    this.parent.append(this.input_select);
    this.parent.append(this.button_clear);
    this.parent.append(this.div_current);
    this.parent.append(this.div_customers);
    this.parent.append(this.input_json);

    for (const customer of customers) {
      const input_checkbox     = document.createElement('input');
      const label_customer     = document.createElement('label');
      label_customer.innerText = customer.customerName;
      input_checkbox.type      = 'checkbox';
      input_checkbox.name      = customer.customerId;
      input_checkbox.checked   = customer.selected;
      cUtil.labelIds(label_customer, input_checkbox);
      this.div_customers.append(input_checkbox);
      this.div_customers.append(label_customer);
    }

    // ---- Texts ----
    this.label_title.innerText    = 'Kunden';
    this.input_select.placeholder = 'Kundensuche';
    this.button_clear.innerText   = 'Alle löschen';

    
    // ---- Other ----
    this.input_select.type = 'text';
    this.input_json.type   = 'hidden';
    this.input_json.name   = 'c-customers';
    this.button_clear.type = 'button';

    // ---- Styles ----

    this.div_current.style.gridColumn = '2/4';

    this.div_customers.style.display             = 'grid';
    this.div_customers.style.gridColumn          = '2/4';
    this.div_customers.style.gridTemplateColumns = 'auto 1fr';
    this.div_customers.style.gridTemplateRows    = 'repeat(auto-fill, 30px)';
    this.div_customers.style.alignItems          = 'center';
    this.div_customers.style.height              = '250px';
    this.div_customers.style.overflowY           = 'scroll';
    this.div_customers.style.overflowX           = 'hidden';
    this.div_customers.style.padding             = '3px';

    // ---- Events ----
    this.input_select.addEventListener('keyup', () => { 
      const allLabels = this.div_customers.querySelectorAll('label') as unknown as HTMLLabelElement[];
      const input = this.input_select.value.toLowerCase();

      for(const label of allLabels) {
        const id       = label.getAttribute('for');
        const checkbox = this.div_customers.querySelector(`input#${id}`);

        if (label.innerText.toLowerCase().includes(input)) {
          label.classList.remove('c-hidden');
          checkbox?.classList.remove('c-hidden');
        }
        else {
          label.classList.add('c-hidden');
          checkbox?.classList.add('c-hidden');
        }
      }
    });

    const checkboxes = this.div_customers.querySelectorAll('input') as unknown as HTMLInputElement[];

    for (const checkbox of checkboxes) {
      checkbox.addEventListener('change', () => {
        const customerSelected = customers.filter(customer => customer.customerId === checkbox.name);
        customerSelected.forEach(customer => customer.selected = checkbox.checked);
        this.input_json.value = JSON.stringify(customers);
        this.currentCustomers(customers);
      });
    }

    this.button_clear.addEventListener('click', () => {
      for (const checkbox of checkboxes) {
        checkbox.checked = false;
      }
      for (const customer of customers) {
        customer.selected = false;
      }
      this.input_json.value = JSON.stringify(customers);
      this.currentCustomers(customers);
    });

    // ---- Init ----
    this.input_json.value = JSON.stringify(customers);
    this.currentCustomers(customers);

  }

  currentCustomers(customers: UserCustomer[]) {

    this.div_current.innerHTML = '';

    const label = document.createElement('label')
    const ul    = document.createElement('ul');

    this.div_current.append(label);
    this.div_current.append(ul);

    customers
    .filter(item => item.selected)
    .map(item => item.customerName)
    .sort()
    .forEach(name => {
      const li = document.createElement('li');
      ul.append(li);
      li.innerText = name;
      li.style.margin = '0';
    });

    label.innerText = ul.hasChildNodes() ? 'Zugewiesene Kunden:' : '';

    ul.style.marginTop  = '0';
    label.style.padding = '0';
  }
}


